// extracted by mini-css-extract-plugin
export var button = "DownloadForm-module--button--102fc";
export var error = "DownloadForm-module--error--a6b20";
export var form = "DownloadForm-module--form--7beda";
export var h3 = "DownloadForm-module--h3--247cb";
export var inputButton = "DownloadForm-module--inputButton--14a0e";
export var lgBreak = "1200";
export var mdBreak = "992";
export var section = "DownloadForm-module--section--14a9a";
export var smBreak = "768";
export var xsBreak = "480";